import { App } from './../app.class';
import { Modal } from './../modal.class';
import { Notification } from './../notification.class';
import { Fetch } from '../../fetch.class';
import ClipboardJS from 'clipboard';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;

        // Basis-URL zu Prozessor
        this.baseUrl = App.getUrl('form-delivery')+"/"+this.form_code+"/webhook";


        // --- Webadresse

        // Elemente
        this.$btnEditUrl = document.querySelector('button.url');
        this.$inputEditUrl = document.querySelector('#modal-edit-url input[name=url]');
        this.$displayUrl = document.querySelector('#value_url');
        this.$formEditUrl = document.querySelector('#modal-edit-url form');
        this.$errorboxEditUrl = document.querySelector('#modal-edit-url .errorbox');

        // Modal
        this.modalEditUrl = new Modal('#modal-edit-url');

        // Modaldialog öffnen
        this.$btnEditUrl.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditUrl.classList.add('hidden');

            // Modal öffnen
            this.modalEditUrl.show();
        });

        // Speicherung
        this.$formEditUrl.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("url", this.$inputEditUrl.value);

            // Fehler ausblenden
            this.$errorboxEditUrl.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_url", data)
            .then(response => {

                // Modal schliessen
                this.modalEditUrl.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayUrl.textContent = this.$inputEditUrl.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditUrl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditUrl.classList.remove('hidden');
            });
        });


        // Kopierfunktion für Authentifizierungsdaten
        const btnsCopy = document.querySelectorAll("a.copy");
        btnsCopy.forEach($btnCopy => {

            const templateClipboard = new ClipboardJS($btnCopy, {
                text: function(trigger) {
                    const selectorStr = trigger.dataset.selectorId ?? null;

                    console.log(selectorStr);

                    if(selectorStr) {
                        const $ele = document.querySelector("#"+selectorStr);
                        if($ele) {
                            let text = $ele.textContent.trim();
                            return text;
                        }
                    }
                }
            });
            templateClipboard.on('success', event => {
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new Notification().success(msg);
            });

        });

    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-delivery-webhook')) {
        new Page();
    }
});